module.exports = __webpack_public_path__ + "static/media/tjt_mc.dfdfc33e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/tjt_mc.png
 ** module id = 1664
 ** module chunks = 0
 **/